export const checkIfSubMenuHasPermissionTrue = item => {
  if (item.subMenu && item.subMenu.length > 0) {
    const permission = item.subMenu.some(subItem => subItem.acesso === true);
    return !permission;
  }

  return !item.acesso;
};

// Telas do módulo de almoxarifado — só aparecem no menu quando a empresa tem
// `habilitarModuloAlmoxarifados` ligado no cadastro (/v1/empresas/{id})
const ALMOXARIFADO_URLS = ['/almoxarifado/solicitacoes', '/almoxarifado/movimentacao'];

const isAlmoxarifadoItem = item => ALMOXARIFADO_URLS.some(url => item.url?.toLowerCase().includes(url));

export const menuAdmin = (data, { habilitarModuloAlmoxarifados = true } = {}) => {
  const menu = {
    first: data[0]?.menu
      ?.filter(item => item.nome !== 'Home')
      ?.map(item => {
        const menuItem = {
          label: item.nome,
          link: item.url,
          disabled: checkIfSubMenuHasPermissionTrue(item),
          isExternal: true,
        };

        if (item.subMenu && item.subMenu.length > 0) {
          menuItem.children = item.subMenu
            .filter(subItem => habilitarModuloAlmoxarifados || !isAlmoxarifadoItem(subItem))
            .map(subItem => ({
              label: subItem.nome,
              link: subItem.url,
              disabled: !subItem.acesso,
              isExternal: true,
            }));
        }

        return menuItem;
      }),
  };

  return menu;
};
